export const XP_VALUES = {
  correctAnswer: 10,
  boxPromotion: {
    2: 5,
    3: 10,
    4: 20,
    5: 50,
  } as Record<number, number>,
  dailyStreakShort: 25,
  dailyStreakLong: 50,
  dailyStreakLongThreshold: 7,
  categoryMastery: 200,
} as const;

export interface LevelInfo {
  level: number;
  titleKey: string;
  xpRequired: number;
}

export const LEVELS: LevelInfo[] = [
  { level: 1, titleKey: 'xp.level.1', xpRequired: 0 },
  { level: 2, titleKey: 'xp.level.2', xpRequired: 100 },
  { level: 3, titleKey: 'xp.level.3', xpRequired: 500 },
  { level: 4, titleKey: 'xp.level.4', xpRequired: 1_500 },
  { level: 5, titleKey: 'xp.level.5', xpRequired: 4_000 },
  { level: 6, titleKey: 'xp.level.6', xpRequired: 8_000 },
  { level: 7, titleKey: 'xp.level.7', xpRequired: 15_000 },
  { level: 8, titleKey: 'xp.level.8', xpRequired: 25_000 },
  { level: 9, titleKey: 'xp.level.9', xpRequired: 38_000 },
  { level: 10, titleKey: 'xp.level.10', xpRequired: 55_000 },
];

export interface LevelProgress {
  level: number;
  titleKey: string;
  currentXp: number;
  xpForCurrentLevel: number;
  xpForNextLevel: number | null;
  xpIntoLevel: number;
  xpNeededForNext: number;
  progress: number;
  isMaxLevel: boolean;
}

export function getLevelForXp(xp: number): LevelProgress {
  let currentLevel = LEVELS[0];

  for (const level of LEVELS) {
    if (xp >= level.xpRequired) {
      currentLevel = level;
    } else {
      break;
    }
  }

  const isMaxLevel = currentLevel.level === LEVELS[LEVELS.length - 1].level;
  const nextLevel = isMaxLevel ? null : LEVELS[currentLevel.level];
  const xpForNext = nextLevel?.xpRequired ?? null;
  const xpInto = xp - currentLevel.xpRequired;
  const xpNeeded = xpForNext ? xpForNext - currentLevel.xpRequired : 0;
  const progress = xpNeeded > 0 ? xpInto / xpNeeded : 1;

  return {
    level: currentLevel.level,
    titleKey: currentLevel.titleKey,
    currentXp: xp,
    xpForCurrentLevel: currentLevel.xpRequired,
    xpForNextLevel: xpForNext,
    xpIntoLevel: xpInto,
    xpNeededForNext: xpNeeded,
    progress: Math.min(1, progress),
    isMaxLevel,
  };
}
